import React, { useState, useEffect } from "react";
import Select from "react-select";
import SelectStudentFeeModal from "../FeeStudentModal/SelectStudentFeeModal";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";

const AdmAttendanceEntry = () => {
  const [studentName, setStudentName] = useState("");
  const [studentId, setStudentId] = useState("");
  const [show, setShow] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [mentors, setMentors] = useState([]);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [selectedStudentOption, setSelectedStudentOption] = useState(null);
  const navigate = useNavigate();
  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  const academicYearId = localStorage.getItem("academicSessionId");
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleSelectStudent = (selectedStudent) => {
    // const fullName = [
    //   selectedStudent.studentBasicDetails.first_name || "",
    //   selectedStudent.studentBasicDetails.middle_name || "",
    //   selectedStudent.studentBasicDetails.last_name || "",
    // ]
    //   .filter(Boolean)
    //   .join(" ");

    // Set studentId when selecting a student (we will use this for the search)
   setStudentId(selectedStudent.studentId || "");
   setStudentName(selectedStudent.studentname || ""); // Set student name for display (not used for search)
    // setClassId(selectedStudent.studentBasicDetails.addmitted_class || null);
    // setSectionId(selectedStudent.studentBasicDetails.addmitted_section || null);

    handleClose();
  };

  const handleAssignMentorClick = () => {
    navigate("/admin/assign-student-mentor");
  };

  const handleMentorChange = async (mentor) => {
    setSelectedMentor(mentor);
    setSelectedStudentOption(null);
    setStudentId("");
    setStudentName("");
    setAssignedStudents([]);

    if (!mentor) return;

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Mentor/studentmentorAssignSearch/?academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}&teacher_id=${mentor.value}`
      );
      const data = await response.json();
      if (data && data.message === "success" && data.data) {
        const options = data.data
          .filter((s) => s.student_id && s.studentname !== "No students assigned")
          .map((s) => ({
            value: s.student_id,
            label: s.studentname,
          }));
        setAssignedStudents(options);
      }
    } catch (error) {
      console.error("Error fetching assigned students:", error);
    }
  };

  useEffect(() => {
    const fetchMentors = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=${orgId}&branchId=${branchId}`
        );
        const data = await response.json();
        if (data && data.data) {
          const formattedMentors = data.data.map((mentor) => ({
            value: mentor.id,
            label: mentor.employeeName,
          }));
          setMentors(formattedMentors);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
      }
    };

    fetchMentors();
  }, [orgId, branchId]);

  const handleSearch = async () => {
    const teacherId = selectedMentor ? selectedMentor.value : "";
    const selectedStudentId = selectedStudentOption ? selectedStudentOption.value : (studentId || "");

    let queryParams = `academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}`;
    if (teacherId) queryParams += `&teacher_id=${teacherId}`;
    if (selectedStudentId) queryParams += `&student_id=${selectedStudentId}`;

    const apiUrl = `${ApiUrl.apiurl}Mentor/studentmentorAssignSearch/?${queryParams}`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      if (data.message === "success" && data.data) {
        setTableData(data.data);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setTableData([]);
    }
  };

  const handleClear = () => {
    setSelectedMentor(null);
    setSelectedStudentOption(null);
    setAssignedStudents([]);
    setTableData([]);
    setStudentId("");
    setStudentName("");
  };

  const handleDelete = async (assignedId) => {
    if (!assignedId) return;
    if (!window.confirm("Are you sure you want to delete this assignment?")) return;
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Mentor/studentmentorDelete/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ assigned_id: assignedId }),
        }
      );
      const data = await response.json();
      if (data.message === "success") {
        setTableData((prev) => prev.filter((item) => item.assigned_id !== assignedId));
        // Refresh assigned students dropdown
        if (selectedMentor) {
          const res = await fetch(
            `${ApiUrl.apiurl}Mentor/studentmentorAssignSearch/?academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}&teacher_id=${selectedMentor.value}`
          );
          const d = await res.json();
          if (d && d.message === "success" && d.data) {
            const options = d.data
              .filter((s) => s.student_id && s.studentname !== "No students assigned")
              .map((s) => ({
                value: s.student_id,
                label: s.studentname,
              }));
            setAssignedStudents(options);
          } else {
            setAssignedStudents([]);
          }
        }
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (error) {
      console.error("Error deleting assignment:", error);
    }
  };

  const handleCloseBut = () => {
    navigate("/admin/dashboard");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT MENTOR
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleAssignMentorClick}
                  >
                    Assign Mentor
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleClear}
                    style={{ width: "150px" }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    onClick={handleCloseBut}
                    style={{ width: "150px" }}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 p-2 mt-3 mb-3 ">
                      {/* Mentor Dropdown */}
                      <div className="col-12 col-md-4 d-flex align-items-center  mb-6">
                        <label
                          htmlFor="mentor"
                          className="form-label me-2   "
                          style={{ whiteSpace: "nowrap", minWidth: "110px" }}
                        >
                          Mentor
                        </label>
                        <div className="d-flex flex-grow-1">
                          <Select
                            id="mentor"
                            options={mentors}
                            className="detail w-100"
                            value={selectedMentor}
                            onChange={handleMentorChange}
                            placeholder="Select Mentor"
                            classNamePrefix="mentor-dropdown"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4 d-flex align-items-center">
                        <label
                          htmlFor="student-name"
                          className="form-label me-2"
                          style={{ whiteSpace: "nowrap", minWidth: "110px" }}
                        >
                          Student Name
                        </label>
                        <div className="d-flex flex-grow-1">
                          {selectedMentor ? (
                            <Select
                              id="student-name"
                              options={assignedStudents}
                              className="detail w-100"
                              value={selectedStudentOption}
                              onChange={setSelectedStudentOption}
                              placeholder="Select Student"
                              isClearable
                              classNamePrefix="student-dropdown"
                            />
                          ) : (
                            <>
                              <input
                                type="text"
                                className="form-control detail"
                                placeholder="Enter student name"
                                value={studentName}
                                onChange={(e) => setStudentName(e.target.value)}
                                disabled
                              />
                              <button
                                type="button"
                                className="btn btn-primary btn-sm ms-2 mb-0 mt-0"
                                onClick={handleShow}
                                style={{ width: "50px", backgroundColor: "#0D6EFD", borderColor: "#0D6EFD" }}
                              >
                                ...
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                      <SelectStudentFeeModal
                        show={show}
                        handleClose={handleClose}
                        onSelectStudent={handleSelectStudent}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Table Data */}

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered ">
                    <thead
                      style={{ backgroundColor: "#2b7be5", color: "white" }}
                    >
                      <tr>
                        <th>SL. NO.</th>
                        <th>Mentor Name</th>
                        <th>Student Name</th>
                        <th>Admission No</th>
                        <th>Roll no</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Assignment Date</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.length > 0 ? (
                        tableData.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.mentor_name}</td>
                            <td>{item.studentname}</td>
                            <td>{item.admission_no || "-"}</td>
                            <td>{item.rollNo || "N/A"}</td>
                            <td>{item.classname || "-"}</td>
                            <td>{item.sectionname || "-"}</td>
                            <td>{item.assignment_date || "-"}</td>
                            <td>
                              {item.assigned_id ? (
                                <span
                                  style={{
                                    backgroundColor: item.is_active ? "#28a745" : "#dc3545",
                                    color: "white",
                                    padding: "2px 10px",
                                    borderRadius: "4px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {item.is_active ? "ACTIVE" : "INACTIVE"}
                                </span>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              {item.assigned_id ? (
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDelete(item.assigned_id)}
                                >
                                  Delete
                                </button>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
